import { useState, useEffect, } from 'react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import cn from 'classnames';

import { 
  settingsNumberFields, 
  settingsCheckboxFields,
  settingsDropdownFields,
  settingsExcludedFields,
} from '../../constants/settingFields';
import { getSettings, updateSettings } from '../../actions/settings';
import { deleteCohorts} from '../../actions/dish';
import styles from './Settings.module.css';

const Settings = (props) => {
  const { 
    getSettings, 
    updateSettings,
    deleteCohorts,
    settingsData,
  } = props;

  const [settings, setSettings] = useState([]);

  useEffect(() => {
    getSettings();
  }, []);

  useEffect(() => {
    setSettings(settingsData);
  }, [settingsData]);

  const changeSettingsHandler = (id, value) => {
    const settingIndex = settings.findIndex(setting => setting.id === id);
    settings[settingIndex].value = value;
    setSettings([...settings]);
  };

  const saveSettingData = (id) => {
    const settingToSave = settings.find(setting => setting.id === id);
    updateSettings(settingToSave, () => {
      return toast.success('Settings was saved', {
        position: 'bottom-right',
        duration: 3000,
      });
    });
  };

  const deleteCohortsHandler = () => {
    const confirmResult = window.confirm('Are you sure?');

    if (confirmResult) {
      deleteCohorts(() => {
        return toast.success('The cohorts have been deleted', {
          position: 'bottom-right',
          duration: 3000,
        });
      });
    }
  };

  const renderInput = (setting) => {
    if (settingsNumberFields[setting.field]) {
      return (
        <input 
          className={styles.input}
          value={setting.value} 
          onChange={({ target }) => changeSettingsHandler(setting.id, target.value)}
        />
      );
    }

    if (settingsCheckboxFields[setting.field]) {
      return (
        <span className={styles.checkbox}>
          <input  
            checked={setting.value == '1'}
            onChange={({ target }) => changeSettingsHandler(setting.id, target.checked)}
            type="checkbox"
          />
        </span>
      );
    }

    const options = settingsDropdownFields[setting.field];

    if (options) {
      return (
        <span className={styles.checkbox}>
          <select
            className={styles.select}
            value={setting.value} 
            onChange={({ target }) => changeSettingsHandler(setting.id, target.value)}
          >
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </span>
      );

    }

    return (
      <textarea 
        className={styles.textarea}
        value={setting.value} 
        onChange={({ target }) => changeSettingsHandler(setting.id, target.value)}
      />
    );
  };

  const renderRow = (setting) => {
    if (settingsExcludedFields[setting.field]) {
      return false;
    }

    return (
      <div key={setting.id} className={styles.rowWrapper}>
        {setting.field === 'MACRO_TOLERANCE_MIN' && (
          <div className={styles.balanceSettings}>Balance Settings</div>
        )}
        <div className={styles.row}>
          <label>
            <span className={styles.labelText}>{setting.label}:</span>
            {renderInput(setting)}
          </label>
          <button 
            className="button green-button" 
            onClick={() => saveSettingData(setting.id)}
          >
            Save
          </button>
        </div>
        {setting.description && (
          <div className={styles.description}>{setting.description}</div>
        )}
      </div>
    );
  };

  if (!settings.length) {
    return null;
  }

  return (
    <div className="wrapper">
      <h1>
        Settings
      </h1>
      {settings.map(renderRow)}
      <button 
        className={cn('button red-button', styles.deleteCohorts)} 
        onClick={deleteCohortsHandler}
      >
        Delete cohorts
      </button>
    </div>
  );
};

const mapStateToProps = (store) => ({
  settingsData: store.settings.settingsData,
});

const mapDispatchToProps = {
  getSettings, 
  updateSettings,
  deleteCohorts,
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);